function compte_a_rebours() {
  var compte_a_rebours = document.getElementById("p");

  var date_actuelle = new Date();
  //var date_evenement = new Date("May 27 09:00:000 2018");
  var date_evenement = new Date("September 22 09:00:000 2024");
  var date_lancement = new Date("May 1 00:00:00 2019");

  var date_results = new Date("Jun 1 13:00:00 2021");
  var total_results = (date_results - date_actuelle) / 1000;

  var total_secondes = (date_evenement - date_actuelle) / 1000;


  function diffdate(d1, d2, u) {
    div = 1
    switch (u) {
      case 's':
        div = 1000;
        break;
      case 'm':
        div = 1000 * 60
        break;
      case 'h':
        div = 1000 * 60 * 60
        break;
      case 'd':
        div = 1000 * 60 * 60 * 24
        break;
    }

    var Diff = d2.getTime() - d1.getTime();
    return Math.ceil((Diff / div))
  }

  var total_jours = diffdate(date_lancement, date_evenement, 'd');


  if (total_secondes < 0) {
    //cas ou il est fini et on affiche depuis combien de temps il est fini
  }

  if (total_secondes > 0) {
    var jours = Math.floor(total_secondes / (60 * 60 * 24));
    var heures = Math.floor((total_secondes - (jours * 60 * 60 * 24)) / (60 * 60));
    var minutes = Math.floor((total_secondes - ((jours * 60 * 60 * 24 + heures * 60 * 60))) / 60);
    var secondes = Math.floor(total_secondes - ((jours * 60 * 60 * 24 + heures * 60 * 60 + minutes * 60)));

    function timeInDeg(_elem, _class) {
      var deg = (360 / 60) * (60 - _elem);
      if (_class == "heures") {
        deg = (360 / 24) * (24 - _elem);
      }
      if (_class == "jours") {
        deg = (360 / total_jours) * (total_jours - _elem);
      }
      if (deg < 180) {
        $("." + _class + " #portion2").css("transform", "rotate(" + 0 + "deg)");
        $("." + _class + " #portion1 .embed").css("transform", "rotate(" + deg + "deg)");
        $("." + _class + " #portion2 .embed").css("transform", "rotate(" + deg + "deg)");
      } else {
        $("." + _class + " #portion1 .embed").css("transform", "rotate(180deg)");
        $("." + _class + " #portion2 .embed").css("transform", "rotate(180deg)");
        deg = deg - 180;
        if (deg >= 180) deg = 178
        $("." + _class + " #portion2").css("transform", "rotate(" + deg + "deg)");
      }
      if (_elem > 99) {
        $("." + _class + " #time").css("left", "-6px");
      }
      $("." + _class + " #time").html(_elem);
    }
    timeInDeg(secondes, "secondes");
    timeInDeg(minutes, "minutes");
    timeInDeg(heures, "heures");
    timeInDeg(jours, "jours");

  } else {
    //Compte à rebours terminé

    // Section "C'est parti" + compteur
    var live_div = $('.section-live-hide');
    var results_div = $('.section-results-hide')

    var depart_div = $('.section-depart-to-hide h1 h4');

    var container_depart = $('.container-compteur');
    var ie9_compteur = $('.ie9-compteur--time');

    $(live_div).removeClass('section-live-hide');
    $(live_div).addClass('section-live-to-hide');


    $(depart_div).removeClass('section-depart-to-hide');
    $(depart_div).addClass('section-depart-hide');

    //$(container_depart).hide();
    $(ie9_compteur).hide();

    $('.section-live-to-hide h1').css({
      "visibility": "visible",
      "animationName": "fadeInDown",
      "marginBottom": "45px",
    })

    $('.section-depart-to-hide h1').css({
      "display": "none",
    })

    $('.section-depart-to-hide h4').css({
      "display": "none",
    })

    //Gestion de l'apparition du "Félicitations + Afficher les résultats" à la fin de la course
    if (total_results < 0) {
      $(results_div).removeClass('section-results-hide');
      $(results_div).addClass('section-results-to-hide');
      $('.section-results-to-hide h1').css({
        "visibility": "visible",
        "animationName": "fadeInDown",
        "marginBottom": "45px",
      })

      $('.section-live-to-hide h1').css({
        "display": "none",
      })

      $('.section-live-to-hide a').css({
        "display": "none",
      })

      $('.section-depart-to-hide').css({
        "display": "none",
      })
    }
    //new WOW().init();

  }
}



compte_a_rebours();
var actualisation = setInterval(function() {
  compte_a_rebours();
}, 1000);
